import React, { useContext, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const NotificationModal = () => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { notificationBanner, closeNotificationBanner } =
    adminRegistrationContext;

  const { type, message } = notificationBanner;

  const backgroundColor = {
    warning: "#d8302f",
    success: "#537131",
  };

  useEffect(() => {
    setTimeout(() => {
      closeNotificationBanner();
    }, 5000);
  }, []);
  return (
    <div id="notification-modal" style={{ background: backgroundColor[type] }}>
      <div className="top">
        <FaIcons.FaTimes
          className="modal-close-icon"
          onClick={closeNotificationBanner}
        />
      </div>
      <p>{message}</p>
    </div>
  );
};

export default NotificationModal;
